import { createApp } from "vue";
import store from "./store";
import router from "./storefrontRouter";
import Storefront from "@/storefront/Storefront.vue";
import includes from "@/services/storefrontIncludes";
import "@sass/widget.scss";

// initialize app
const app = createApp(Storefront);

// use store and router
app.use(store);
app.use(router);

includes(app);

// mount app
app.mount("#public-profile");
window.__dismissBootLoader?.();
